// import heroImage from "../images/hero.jpg";

const actingData = [
  {
    title: "The Taming of the Shrew - Huntsville Shakespeare Festival - 2026",
    role: "Baptista",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.uah.edu/ahs/departments/theatre-film/huntsville-shakespeare/current-season",
        text: "Huntsville Shakespeare Festival"
      }
    ]
  },
  {
    title: "A Midsummer Night's Dream - Company - 2023",
    role: "Quince/Egeus/Fairy",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "That Dreded Life - Company - 2023",
    role: "Mrs. Emmerson",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "The Complete Works of William Shakespeare Abridged - Company - 2022",
    role: "Jess",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "Othello - Company - 2021",
    role: "Biance/Duke/Montano",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "Hamlet - Company - 2020",
    role: "Horatio",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "Twelfth Night - Company - 2018",
    role: "Sir Andrew",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "The Laramie Project - UAH Theatre - 2015",
    role: "Reggie/Kerry/Reporter",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.uah.edu/ahs/departments/theatre-film",
        text: "University of Alabama Huntsville Theatre Dept."
      }
    ]
  },
  {
    title: "Scenes and Revelations - NEMCC Theatre - 2012",
    role: "Helena",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.nemcc.edu/fine-arts/",
        text: "Northeast Mississippi Community College Theater Dept."
      }
    ]
  },
  {
    title: "Working: The Musical - NEMCC Theatre - 2009",
    role: "Chorus/Hooker",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.nemcc.edu/fine-arts/",
        text: "Northeast Mississippi Community College Theater Dept."
      }
    ]
  },
  {
    title: "Star Spangled Girl - Tupelo Community Theatre - 2009",
    role: "Sophie",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://tctlyric.com/",
        text: "Tupelo Community Theatre"
      }
    ]
  },
  {
    title: "The “M” Word - Company - 2008",
    role: "Woman",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "Laundry and Bourbon - NEMCC Theatre - 2008",
    role: "Amy",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.nemcc.edu/fine-arts/",
        text: "Northeast Mississippi Community College Theater Dept."
      }
    ]
  },
  {
    title: "Southern Girls - NEMCC Theatre - 2007",
    role: "Dolly",
    images: [
      
    ],
    description: "",
    links: [
      {
        url: "https://www.nemcc.edu/fine-arts/",
        text: "Northeast Mississippi Community College Theater Dept."
      }
    ]
  }
];

export default actingData;


// {
//     title: "Title",
//     role: "Role",
//     images: [
//       
//     ],
//     description: "",
//     credits: "credits",
//     links: [
//       {
//         url: "https://www.theatrehsv.org/",
//         text: "Theatre Huntsville"
//       },
//       {
//         url: "https://www.theatrehsv.org/",
//         text: "Theatre Huntsville"
//       }
//     ]
//   }